import type { RouteExpenseAllocationCandidate } from '../../../store/api/financeApi';

export function mapRouteExpenseAllocationCandidates(
  candidates: RouteExpenseAllocationCandidate[]
): Array<{ applicationId: number; number?: string; label: string }> {
  return candidates.map((candidate) => ({
    applicationId: candidate.applicationId,
    number: candidate.number,
    label: candidate.number ? `#${candidate.number}` : `#${candidate.applicationId}`
  }));
}
